export function sortTimes(times: string[]) {
  return times.sort((a, b) =>
    a.localeCompare(b, undefined, { numeric: true })
  );
}